<div class="search-input-form">
  <form style="padding: 5px 15px;" (ngSubmit)="search()">
    <mat-form-field [style.width.%]="25">
      <mat-label>{{FORM_INFO.SEARCH_INPUT_LABEL}}</mat-label>
      <input type="text" matInput
             [formControl]="queryFormControl"
             name="queryText"
             placeholder="{{FORM_INFO.SEARCH_INPUT_PLACEHOLDER}}" alt="{{FORM_INFO.SEARCH_INPUT_ALT}}" required/>

      <button mat-button matSuffix mat-icon-button type="submit" [disabled]="!queryFormControl.valid">
        <mat-icon>search</mat-icon>
      </button>
      <mat-hint></mat-hint>
      <button mat-button *ngIf="queryFormControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="clearInput()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="queryFormControl.hasError('required')">
        {{FORM_INFO.SEARCH_INPUT_REQUIRED_ERROR}}
      </mat-error>
      <mat-error *ngIf="errors.isEmptyResult">
        {{FORM_INFO.SEARCH_INPUT_NO_ITEMS_FOUND_ERROR}}
      </mat-error>
    </mat-form-field>
  </form>
</div>
<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="dataSource" class="details-screen-table online-key-search-table">
  <ng-container matColumnDef="icon">
    <th mat-header-cell *matHeaderCellDef> Details </th>
    <td mat-cell *matCellDef="let data">
      <div class='data-field-table details-button'>
        <span>
          <rfs2-icon name='info-supercircle' class='details-icon-table'></rfs2-icon>
        </span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="arrangementNumber">
    <th mat-header-cell *matHeaderCellDef> Overeenkomstnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.arrangementNumber ? data.arrangementNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Overeenkomststatus </th>
    <td mat-cell *matCellDef="let data"> {{data.status ? data.status : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cardType">
    <th mat-header-cell *matHeaderCellDef> Passoort </th>
    <td mat-cell *matCellDef="let data"> {{data.cardType ? data.cardType : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cardArrangementNumber">
    <th mat-header-cell *matHeaderCellDef> Pasovereenkomstnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.cardArrangementNumber ? data.cardArrangementNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cardArrangementStatus">
    <th mat-header-cell *matHeaderCellDef> Pasovereenkomststatus </th>
    <td mat-cell *matCellDef="let data"> {{data.cardArrangementStatus ? data.cardArrangementStatus : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="settlementAccountNumber">
    <th mat-header-cell *matHeaderCellDef> Afrekenrekeningnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.settlementAccountNumber ? data.settlementAccountNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cardNumber">
    <th mat-header-cell *matHeaderCellDef> Pasnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.cardNumber ? data.cardNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="sequenceNumber">
    <th mat-header-cell *matHeaderCellDef> Volgnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.sequenceNumber ? data.sequenceNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="replacedSequenceNumber">
    <th mat-header-cell *matHeaderCellDef> Vervangt volgnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.replacedSequenceNumber ? data.replacedSequenceNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cardHolder">
    <th mat-header-cell *matHeaderCellDef> Pashouder </th>
    <td mat-cell *matCellDef="let data"> {{data.cardHolder ? data.cardHolder : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cardStatus">
    <th mat-header-cell *matHeaderCellDef> Passtatus </th>
    <td mat-cell *matCellDef="let data"> {{data.cardStatus ? data.cardStatus : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cancellationDate">
    <th mat-header-cell *matHeaderCellDef> Datum vervallen </th>
    <td mat-cell *matCellDef="let data"> {{data.cancellationDate ? data.cancellationDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="relatedRelation">
    <th mat-header-cell *matHeaderCellDef> Klant / Partij </th>
    <td mat-cell *matCellDef="let data"> {{data.relatedRelation ? data.relatedRelation : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row (click)="navigateToOnlineKeyDetail(row)" class="hover-table" *matRowDef="let row; columns: tableColumns;"></tr>

</table>

<mat-paginator
  *ngIf='showTable'
  [length]="localPaginationObj.totalNumberOfCards"
  [pageSize]="localPaginationObj.resultsPerPage"
  (page)="pageEvent = paginate($event)"
  showFirstLastButtons></mat-paginator>

<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>

